// helper that can be used on the sign up form -- and soon login and forgot password
import { ProPageStrings } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

// todo move validators to text fields similar to https://react-hook-form.com/get-started#Applyvalidation
const validateUserForm = (name, value, errors) => {
  const { email, password, firstName, lastName } = ProPageStrings.loginForm;
  switch (name) {
    case 'forgotPasswordEmail':
    case 'userRegEmail':
    case 'userEmail':
      if (!validEmailRegex.test(value)) {
        errors[name] = email.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    case 'userRegPassword':
    case 'userPassword':
    case 'password':
    case 'confirmPassword':
      if (value.length < 6) {
        errors[name] = password.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    case 'userRegFirstName':
      if (value.length < 1) {
        errors[name] = firstName.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    case 'userRegLastName':
      if (value.length < 1) {
        errors[name] = lastName.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    default:
      break;
  }

  return { errors };
};

const hasErrors = errors => {
  for (const name in errors) {
    if (errors[name].length > 0) {
      return true;
    }
  }
  return false;
};

export { validateUserForm, hasErrors, validEmailRegex };
